module.exports = __webpack_public_path__ + "static/media/guia-internacao-icon.217db01b.svg";